<script setup lang="ts">
type Props = {
  isInsideTopbar?: boolean;
};

const { isInsideTopbar = false } = defineProps<Props>();

type Emits = {
  close: [];
};

const emit = defineEmits<Emits>();

const { modalType } = storeToRefs(useLayoutStore());
</script>

<template>
  <button
    :class="[$style.closeButton, { [$style.isInsideTopbar]: isInsideTopbar }]"
    :data-type="modalType"
    @click="emit('close')"
  >
    <NuxtIcon name="close" />
  </button>
</template>

<style module lang="postcss">
.closeButton {
  @apply w-[40px] h-[40px] absolute top-2 right-2 z-10 text-auth-icon-close bg-auth-bg-close/90 p-2 rounded-[5px] font-[500] transition-none flex justify-center items-center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.4);

  svg {
    @apply text-auth-icon-close fill-auth-icon-close w-[1.2em] h-[1.2em];
  }

  @media (min-width: 769px) {
    @apply -right-[2px] -top-[2px];

    &:hover {
      @apply right-0 top-0;
    }
  }

  &.isInsideBanner {
    @apply top-2 right-2 bg-auth-bg-close/90;
  }

  &.isInsideTopbar {
    @apply shadow-none bg-transparent top-[6px] right-[4px] text-auth-texts/50 w-[28px] h-[28px] p-1.5;

    svg {
      @apply text-auth-texts/50 fill-auth-texts/50 w-[1.2em] h-[1.2em];
    }

    @media (min-width: 768px) {
      @apply top-[10px] right-[10px] w-[32px] h-[32px] p-2;
    }
  }
}
</style>
